import { render, staticRenderFns } from "./DemandComponent.vue?vue&type=template&id=09680280&scoped=true&"
import script from "./DemandComponent.vue?vue&type=script&lang=js&"
export * from "./DemandComponent.vue?vue&type=script&lang=js&"
import style0 from "./DemandComponent.vue?vue&type=style&index=0&id=09680280&scoped=true&lang=css&"
import style1 from "./DemandComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09680280",
  null
  
)

export default component.exports